/**
 * @Author: Lihao sun sunlihao.cosmo@haier.com
 * @Date: 2025-01-06 14:13:09
 * @LastEditors: Lihao sun sunlihao.cosmo@haier.com
 * @LastEditTime: 2025-01-07 11:00:39
 * @FilePath: src/store/utils/route.js
 * @Description: 这是默认设置,可以在设置》工具》File Description中进行配置
 */
/**
 * @Author 22030124/xieyq
 * @Date 2023-11-21 11:30:37
 * @Description 路由工具js
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
// 路由
import router from '@/router/index.js'
// 布局
import Layout from '@/views/index/index.vue'
// 微应用
import subApp from '@/views/sub-app/index.vue'
// iframe应用
import iframeApp from '@/views/iframe/index.vue'
// 外部链接
import hrefApp from '@/views/href/index.vue'
// 子应用
// const subApp = () => import('@/views/sub-app/index.vue')
/**
 * 格式化路由数据
 * @param {*} routes 来源路由列表
 * @returns {void}
 */
export function formatRoute(routes) {
  // 子集
  const children = []
  const oldRoute = [...router.options.routes]
  // 遍历生成路由信息
  routes.forEach((routeItem) => {
    // iframe应用
    if (routeItem.type === 'IFRAME') {
      // 目标路由信息项
      const targetRouteItem = {
        // 路由路径
        path: `/${routeItem.context}`,
        // 组件赋值
        component: iframeApp,
        // 路由名称
        name: `iframe-${routeItem.context}`,
        // 信息项存储
        meta: {
          // 路由信息
          ...routeItem
        }
      }
      // 路由添加
      children.push(targetRouteItem)
    } else if (routeItem.type === 'MICRO_APP') {
      // const SubAppComponent = Vue.extend(subApp)
      // 目标路由信息项
      const targetRouteItem = {
        // 路由路径
        path: `/${routeItem.context}/*`,
        // 组件赋值
        component: Vue.extend({
          ...subApp,
          name: `SubApp${routeItem.context}`
        }),
        // 路由名称
        name: `sub-app-${routeItem.context}`,
        // 信息项存储
        meta: {
          // 路由信息
          ...routeItem
        }
      }
      // 路由添加
      children.push(targetRouteItem)
    } else if (routeItem.type === 'HREF') {
      // 目标路由信息项
      const targetRouteItem = {
        // 路由路径
        path: `/${routeItem.context}/*`,
        // 组件赋值
        component: hrefApp,
        // 路由名称
        name: `href-${routeItem.context}`,
        // 信息项存储
        meta: {
          // 路由信息
          ...routeItem
        }
      }
      // 路由添加
      children.push(targetRouteItem)
    } else if (routeItem.type === 'INNER_APP') {
      const context = '/' + (routeItem.context + '/').split('/')[0]
      const InnerRoute = router.options.routes.find(
        (route) => route.path == context
      )
      if (InnerRoute) {
        const processRoutes = (routes) => {
          routes.forEach((route) => {
            if (!route.children || route.children.length === 0) {
              // 直接修改 meta（保留原有数据）
              route.meta = {
                ...route.meta,
                ...routeItem
              }
            } else {
              processRoutes(route.children)
            }
          })
        }
        processRoutes(InnerRoute.children)
      }
      oldRoute.push(...router.options.routes)
    }
  })
  // 替换当前路由
  router.matcher = new VueRouter({
    mode: 'history',
    routes: [
      ...oldRoute,
      {
        path: '',
        component: Layout,
        // 重定向到第一个子集
        redirect: children.length ? `/${children[0].meta.context}` : '',
        // 子集路由
        children
      }
    ]
  }).matcher
  return children
}

// 查找菜单里第一个链接菜单
export function findFirstRoute(menuList) {
  let firstRoute = ''
  if (menuList && menuList[0] && menuList[0].type === 'PAGE') {
    // 使用可选链操作符防止未定义的情况
    firstRoute = menuList[0]
    return firstRoute
  } else {
    const result = findFirstRoute(menuList[0] && menuList[0].children)
    if (result) {
      // 检查递归结果是否有效
      return result
    }
  }
}
